import { RefreshCw } from "lucide-react";

import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface ScorecardRerunTextButtonProps {
  onClick: () => void;
  isRerunning: boolean;
  isDisabled: boolean;
}

const ScorecardRerunTextButton = ({
  onClick,
  isRerunning,
  isDisabled,
}: ScorecardRerunTextButtonProps) => (
  <Button
    variant="ghost"
    size="sm"
    className="h-6 px-1.5 text-[11px] font-medium text-muted-foreground hover:text-foreground"
    onClick={onClick}
    disabled={isRerunning || isDisabled}
  >
    <RefreshCw className={cn("mr-1 h-3 w-3", isRerunning && "animate-spin")} />
    Re-run
  </Button>
);

export default ScorecardRerunTextButton;
